import api from 'config/axiosConfig';

export const getReferences = () => {
  return api.get('api/services/reference');
};
